// extracted by mini-css-extract-plugin
export default {"control":"control_control__Txkdp","addIcon":"control_addIcon__DtWEL"};